import { PaymentsListDefault, } from "./PaymentsListDefault.tsx";
import { PaymentsListModerator, } from "./PaymentsListModerator.tsx";
import { useModeratorStore, } from "../../../store/moderatorStore.ts";

/**
 * PaymentsList отвечает за отображение списка платежей.
 *
 * На текущем шаге:
 * - пока данные "грузятся" — показываем скелетоны;
 * - когда загрузка завершена и есть платежи — показываем список PaymentCard.
 */
export function PaymentsList() {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator ? <PaymentsListModerator /> : <PaymentsListDefault />}
    </>
  );
}
